module.exports = __webpack_public_path__ + "static/media/logo.ec00df75.png";